import httpRequest from "../../../infrastructure/httphelper";

import sharedGlobals from "../../../sharedglobals";


class ComplaintandFeedbackService {
    constructor() { }
    getInsuredInformationMasters() {
      let url = sharedGlobals.appUrls.insSharedApiUrl + "api/InsShared/GetInsuredInformationMasters";
      return httpRequest({
        url: url,
        method: "POST",
        data: 0,
      });
    }
    getSharedComplaintsMasters() {
      let url = sharedGlobals.appUrls.miCustomerApiUrl + "api/Complaints/GetSharedComplaintsMasters";
      return httpRequest({
        url: url,
        method: "POST",
        data: 0,
      });
    }
    saveDocuments(saveDoc) {
      let url =
        sharedGlobals.appUrls.miCustomerApiUrl + "api/Complaints/SaveDocuments";
      return httpRequest({
        url: url,
        method: "POST",
        data: saveDoc
      });
    }
    getDocumentList(params) {
      let url = sharedGlobals.appUrls.miCustomerApiUrl + "api/Complaints/GetDocumentList";
      return httpRequest({
        url: url,
        method: "POST",
        dataType: 'json',
        params: params,
    
      });
    }
    deleteDocument(deleteDocument) {
      let url = sharedGlobals.appUrls.miCustomerApiUrl + "api/Complaints/DeleteDocument";
      return httpRequest({
        url: url,
        method: "POST",
        dataType: 'json',
        data: deleteDocument,
  
      });
    }
     downloadFile(encryptedId) {
       let url = sharedGlobals.appUrls.insSharedApiUrl + 'api/InsShared/DownloadDocument?encryptedId=' + encodeURIComponent(encryptedId);
       window.open(url);
     }

    getComplaintDetails(para) {
      let url = sharedGlobals.appUrls.miCustomerApiUrl + "api/Complaints/GetComplaintDetails";
      return httpRequest({
        url: url,
        method: "POST",
        dataType: 'json',
        params: para,
    
      });
    }
    getComplaintInfo(para) {
      
      let url = sharedGlobals.appUrls.miCustomerApiUrl + "api/Complaints/GetComplaintInfo";
      return httpRequest({
        url: url,
        method: "POST",
        dataType: 'json',
        params: para,
    
      });
    }
  
    saveComplaintInfo(saveComplaintInfo){ 
      let url = sharedGlobals.appUrls.miCustomerApiUrl + "api/Complaints/SaveComplaintInfo";
      return httpRequest({
        url: url,
        method: "POST",
        dataType: 'json',
        data: saveComplaintInfo,
    
      });
    } 
    saveComplaintInfoWhistleBlowing(saveComplaintInfo){ 
      let url = sharedGlobals.appUrls.miCustomerApiUrl + "api/Complaints/SaveComplaintInfoWhistleBlowing";
      return httpRequest({
        url: url,
        method: "POST",
        dataType: 'json',
        data: saveComplaintInfo,
    
      });
    } 
    getSubLobMasterByLobType(lobId) {
      let url =
        sharedGlobals.appUrls.miCustomerApiUrl + "api/Complaints/GetSubLobMasterByLobType";
      let para = {
        lobId: lobId,
      }
      return httpRequest({
        url: url,
        method: "POST",
        params: para
      });
    }
    getComplaintTypeMasterBySubLobType(lobId,sublobId) {
      let url =
        sharedGlobals.appUrls.miCustomerApiUrl + "api/Complaints/GetComplaintTypeMasterBySubLobType";
      let para = {
        lobId: lobId,
        sublobId:sublobId,
      }
      return httpRequest({
        url: url,
        method: "POST",
        params: para
      });
    }
    saveComment(saveComment){ 
      let url = sharedGlobals.appUrls.miCustomerApiUrl + "api/Complaints/SaveComment";
      return httpRequest({
        url: url,
        method: "POST",
        dataType: 'json',
        data: saveComment,
    
      });
    }  
    
  }

let instance = new ComplaintandFeedbackService();
export default instance;